<template>
    <v-content>
      <v-row>
        <v-btn
          @click.stop="openDialog = true"
          :color="status === 'awaiting' ? mainColor : dispatchColor"
          outlined
        >
          {{status === 'awaiting' ? 'Procesar' : 'Despachar'}}
        </v-btn>
        <v-dialog v-model="openDialog">
          <v-card>
            <v-container>
                <v-row justify="center" class="pb-5">
                    <h2 :style="`color:${title}`">Orden Nro. {{orderId}}</h2>
                </v-row>
                <v-row>
                    <v-col cols="12">
                    <v-row v-if="showExchangeRate" :style="`color:${paragraph}`" class="caption">
                        <v-col cols="10" offset="1" class="pb-0">
                        <p>{{`Tipo de cambio: ${exchangeRate}`}}</p>
                        </v-col>
                    </v-row>
                    <!-------------------------Overview------------------>
                    <v-row style="font-size:14px">
                        <v-col cols="4" offset="4" class="pl-9 pr-9">
                        <v-row :style="`color:${paragraph}`">
                            <v-col cols="6" class="pt-0 pb-0">
                            <p>Subtotal:</p>
                            </v-col>
                            <v-col cols="6" class="pt-0 pb-0">
                            <p class="text-right">{{`${sumTotal} ${currency}`}}</p>
                            </v-col>
                        </v-row>
                        <v-row :style="`color:${paragraph}`">
                            <v-col cols="6" class="pt-0 pb-0">
                            <p>Envío:</p>
                            </v-col>
                            <v-col cols="6" class="pt-0 pb-0">
                            <p class="text-right">{{`${orderObj.billingData.shippingCost} ${currency}`}}</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="pt-0 pb-0">
                            <p class="font-weight-bold mb-0" :style="`color:${title}`">Total a pagar:</p>
                            </v-col>
                            <v-col cols="6" class="pt-0 pb-0">
                            <p class="text-right font-weight-bold mb-0" :style="`color:${title}`">{{`${sumTotal + orderObj.billingData.shippingCost} ${currency}`}}</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pt-0 pb-0" :style="`color:${paragraph}`">
                            <p class="caption">Incluye IVA</p>
                            </v-col>
                        </v-row>
                        </v-col>
                    </v-row>
                    <!-------------------------Items list--------------------->
                    <v-row>
                        <v-col cols="10" offset="1">
                        <h3 :style="`color:${title}`">Artículos</h3>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col
                            v-for="(item, index) in items"
                            :key="index"
                            cols="3"
                            class="mb-5"
                        >
                            <v-card elevation="10">
                              <v-container>
                                <v-img
                                :src="item.imageUrl"
                                aspect-ratio="1"
                                contain
                                class="ml-0"
                                >
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular indeterminate :size="50" :color="mainColor"></v-progress-circular>
                                    </v-row>
                                </template>
                                </v-img>
                                <v-card-title class="pt-7">
                                  <h5 class="font-weight-bold text-center"
                                  :style="`line-height: 1.1;color:${title}; word-break:keep-all`"
                                  >
                                    {{`${item.productName}`}}
                                  </h5>
                                </v-card-title>
                                <v-row class="mt-1" :style="`color:${paragraph}`">
                                  <v-col class="pl-11 caption">
                                    <p v-if="item.sku !== ''"><span :style="`color:${title}`">SKU: </span>{{item.sku}}</p>
                                    <p v-if="item.barcode !== ''"><span :style="`color:${title}`">Código de barras: </span>{{item.barcode}}</p>
                                    <p><span :style="`color:${title}`">Precio de venta: </span>{{`${roundPrice(parseFloat(item.salePrice))} ${item.currency}`}}</p>
                                    <p><span :style="`color:${title}`">Cantidad: </span>{{item.quantity}}</p>
                                    <p
                                        class="ma-0 font-weight-bold body-1"
                                        :style="`color:${title}`"
                                        v-if="item.currency === 'USD'"
                                    >
                                        {{`Total: ${roundPrice(item.quantity * item.salePrice * exchangeRate)} ${currency}`}}
                                    </p>
                                    <p
                                        class="ma-0 font-weight-bold body-1"
                                        :style="`color:${title}`"
                                        v-else
                                    >
                                        {{`Total: ${roundPrice(item.quantity * item.salePrice)} ${currency}`}}
                                    </p>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                        <!----------------Billing data--------------->
                        <v-row class="body-2" :style="border">
                            <v-col  cols="10" offset="1" class="pb-0">
                                <v-row>
                                    <v-col>
                                        <h4 :style="`color:${title}`">Facturar a nombre de:</h4>
                                    </v-col>
                                </v-row>
                                <v-row :style="`color:${paragraph}`">
                                    <v-col class="pt-0 pb-0 pl-5">
                                        <p><span :style="`color:${title}`">Nombre:</span> {{billingName}}</p>
                                        <p><span :style="`color:${title}`">NIT:</span> {{billingNIT}}</p>
                                        <p><span :style="`color:${title}`">Teléfono:</span> {{billingPhone}}</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <!----------------Shipping data-------------->
                        <v-row class="body-2" v-if="orderObj.type === 'pay_on_delivery'">
                            <v-col cols="10" offset="1">
                                <v-row>
                                    <v-col>
                                        <h4 :style="`color:${title}`">Enviar a:</h4>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0 pl-5">
                                        <p :style="`color:${paragraph}`">{{shippingLocation.address}}</p>
                                        <p :style="`color:${paragraph}`">{{shippingLocation.description}}</p>
                                        <a :href="`https://www.google.com/maps/search/?api=1&query=${shippingLocation.lat},${shippingLocation.lng}`" target="_blank">Abrir en Google Maps</a>
                                        <p class="caption" :style="`color:${paragraph}`">En Google Maps usa la vista Satélite para poder ver el marcador de posición.</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="body-2" v-else>
                            <v-col cols="10" offset="1">
                                <v-row>
                                    <v-col>
                                        <h4 :style="`color:${title}`">El cliente recogerá en tienda:</h4>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0 pl-5">
                                        <p :style="`color:${paragraph}`"><span :style="`color:${title}`">Sucursal: </span>{{shippingLocation}}</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-right pa-0" cols="12" >
                        <v-btn
                            @click="closeDialog"
                            outlined
                            :color="mainColor"
                            fab
                            small
                            style="position: fixed; top: 50px; right: 55px;"
                        >
                            X
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="status==='awaiting'">
                    <v-col class="text-right pa-0" cols="12" >
                        <v-btn
                            @click="processOrder"
                            :disabled="onLoading&&status==='awaiting'"
                            :loading="onLoading&&status==='awaiting'"
                            :dark="!onLoading&&status==='awaiting'"
                            :color="mainColor"
                            small
                            width="100px"
                            style="position: fixed; bottom: 95px; right: 55px;"
                        >
                            Procesar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-else-if="status==='processed'">
                    <v-col class="text-right pa-0" cols="12" >
                        <v-btn
                            @click="processOrder"
                            :disabled="onLoading&&status==='processed'"
                            :loading="onLoading&&status==='processed'"
                            :dark="!onLoading&&status==='processed'"
                            :color="dispatchColor"
                            small
                            width="100px"
                            style="position: fixed; bottom: 95px; right: 55px;"
                        >
                            Despachar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-right pa-0" cols="12" >
                        <v-btn
                            @click="cancelOrder"
                            :disabled="onLoading&&status==='cancelled'"
                            :loading="onLoading&&status==='cancelled'"
                            outlined
                            color=red
                            small
                            width="100px"
                            style="position: fixed; bottom: 55px; right: 55px;"
                        >
                            Eliminar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
          </v-card>
      </v-dialog>
    </v-row>
  </v-content>
</template>
<script>
/* eslint-disable no-useless-catch */
import * as util from '../../../util'
import * as constants from '../../../../constants.json'
import { mdiPencil, mdiDelete, mdiMinus, mdiPlus, mdiLocationExit } from '@mdi/js'

export default {
  props: ['orderObj'],

  data () {
    return {
      companyId: '',
      subscriberId: '',
      orderId: '',
      billingName: '',
      billingNIT: '',
      billingPhone: '',
      items: [],
      shippingCost: 0,
      shippingLocation: {},
      pickupLocation: '',
      status: '',
      exchangeRate: 0,
      showExchangeRate: true,
      currency: 'Bs',
      openDialog: false,
      quantityDialog: false,
      // ----------Rules--------------------
      rules: {
        rule1: value =>
          value <= 999 ||
          'Sólo se permite un máximo de 3 dígitos',
        rule2: value =>
          value >= 0 ||
          'No se permiten valores negativos'
      },
      // --------Icons--------
      editIcon: mdiPencil,
      deleteIcon: mdiDelete,
      plusIcon: mdiPlus,
      minusIcon: mdiMinus,
      exitIcon: mdiLocationExit,
      // --------Style--------
      border: 'border-top: 1px solid #e9eaed',
      mainColor: constants.MAINCOLOR,
      dispatchColor: '#ebb119',
      paragraph: '#90908f',
      title: '#525252'
    }
  },

  /**
   * Create view and observe data
   */
  async created () {
    // Fetching the data when the view is created and the data is already being observed
    this.items = this.orderObj.items
    this.billingName = this.orderObj.billingData.billingName
    this.billingNIT = this.orderObj.billingData.billingNIT
    this.billingPhone = this.orderObj.billingData.billingPhone
    this.shippingCost = this.orderObj.billingData.shippingCost
    this.shippingLocation = this.orderObj.shippingLocation
    this.pickupLocation = this.orderObj.shippingLocation
    this.status = this.orderObj.status
    this.companyId = this.orderObj.companyId
    this.subscriberId = this.orderObj.subscriberId
    this.orderId = this.orderObj.orderId
    this.exchangeRate = this.orderObj.billingData.exchangeRate

    this.items.forEach(item => {
      if (item.currency === 'USD') this.showExchangeRate = true
    })
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    },

    sumTotal () {
      let total = 0
      this.items.forEach(item => {
        if (item.currency === 'USD') {
          total += item.quantity * item.salePrice * this.exchangeRate
        } else {
          total += item.quantity * item.salePrice
        }
      })
      return parseFloat(total.toFixed(1))
    }
  },

  methods: {
    /**
       * Change the order's status
       */
    async processOrder () {
      try {
        if (this.status === 'awaiting') {
          confirm('¿Confirmas que quieres procesar esta orden?. Esta acción no se puede deshacer.') && await this.$store.dispatch('actionProcessOrder', {
            companyId: this.companyId,
            subscriberId: this.subscriberId,
            orderId: this.orderId,
            status: 'processed'
          })
          this.$store.commit('mutationSetLoading', true)
          if (this.orderObj.type === 'pay_on_delivery') {
            await util.sendBotMessage(this.subscriberId, this.subscriberId, this.orderId, '__delivering_processed')
          } else if (this.orderObj.type === 'pickup') {
            await util.sendBotMessage(this.subscriberId, this.subscriberId, this.orderId, '__pick_up_processed')
          }
          this.status = 'processed'
        } else if (this.status === 'processed') {
          confirm('¿Confirmas que quieres despachar esta orden?. Esta acción no se puede deshacer.') && await this.$store.dispatch('actionProcessOrder', {
            companyId: this.companyId,
            subscriberId: this.subscriberId,
            orderId: this.orderId,
            status: 'dispatched'
          })
          this.$store.commit('mutationSetLoading', true)
          if (this.orderObj.type === 'pay_on_delivery') {
            await util.sendBotMessage(this.subscriberId, this.subscriberId, this.orderId, '__order_dispatched')
          } else if (this.orderObj.type === 'pickup') {
            await util.sendBotMessage(this.subscriberId, this.subscriberId, this.orderId, '__ready_to_pick_up')
          }
          this.status = 'dispatched'
        }
        this.openDialog = false
        this.$store.commit('mutationSetLoading', false)
      } catch (error) {
        throw error
      }
    },

    /**
     * Change the order's status to cancelled and delete it from the state
     */
    async cancelOrder () {
      this.status = 'cancelled'
      this.$store.commit('mutationSetLoading', true)
      try {
        confirm('¿Confirmas que quieres eliminar esta orden?. Esta acción no se puede deshacer.') && await this.$store.dispatch('actionProcessOrder', {
          companyId: this.companyId,
          subscriberId: this.subscriberId,
          orderId: this.orderId,
          status: 'cancelled'
        })
        this.$store.commit('mutationSetLoading', false)
        this.openDialog = false
      } catch (error) {
        this.$store.commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Round the price to one decimal
     */
    roundPrice (price) {
      return parseFloat(price.toFixed(1))
    },

    /**
     * Close the order dialog
     */
    closeDialog () {
      this.openDialog = false
    }

  }
}
</script>
